import { Skeleton } from "./ui/skeleton";

export const InfoPageSkeleton = ({ testid }) => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12 space-y-4" data-testid={testid}>
    <Skeleton className="h-6 w-40 rounded-full" />
    <Skeleton className="h-10 w-2/3" />
    <Skeleton className="h-16 w-full" />
    <Skeleton className="h-32 w-full" />
  </div>
);
